import { useStateMachine } from "little-state-machine"
import { useIntl } from "react-intl"
import { updateAction } from "utils/littleStateMachine"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { VALIDATION_MESSAGES } from "utils/forms"
import InputTextArea from "components/InputMUI/TextArea"
import { GENERIC_MSGS } from "modules/claims/constants"
import { BUTTON_MESSAGES } from "utils/buttons"
import ProgressBar from "modules/claims/components/StepForm/ProgressBar"
import RadioButton from "components/InputMUI/RadioButton"
import { DEFECTS_MSGS, DEFECTS_OPTIONS } from "./constants"
import { redirectToNextStep } from "../../../utils"
import { useNavigate } from "react-router-dom"

const FacialDefects = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction })

  const defaultValues = { ...state }
  const schema = yup.object({
    description: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    defect: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required))
  })

  const {
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema)
  })

  const onSubmit = (data) => {
    actions.updateAction(data)
    redirectToNextStep(navigate)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputTextArea
        name="description"
        control={control}
        label={DEFECTS_MSGS.description}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.description}
        error={errors.description?.message}
      />
      <RadioButton
        name="defect"
        register={register}
        label={DEFECTS_MSGS.type}
        options={DEFECTS_OPTIONS}
        defaultValue={state.defect}
        error={errors.defect?.message}
      />
      <div className="btn-container">
        <button className="btn btn-dark" type="submit">
          {intl.formatMessage(BUTTON_MESSAGES.ok)}
        </button>
      </div>
      <ProgressBar
        progress={60}
        handleNext={handleSubmit(onSubmit)}
        RoutePrev={state.previousStep}
      />
    </form>
  )
}

export default FacialDefects
